var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"widget__wrapper",class:_vm.textAlign === 'right' ? 'right-aligned' : ''},[_c('h1',[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }